import { Req_GetArticleList,Req_GetArticle } from '@/request/helpCenter'
import { stat } from 'fs';
export default {
  state: {
    menu:[],
    searchArticleId:'',
    helpBoxStatus:false,
    activeIndex:'',
    isAlert:false,
    inHref:''
  },
  mutations: {
    changeNavList(state,payload){
      state.menu = payload
    },
    changeSearchArticleId(state,payload){
      state.searchArticleId = payload
      state.helpBoxStatus = true
    },
    clearSearchArticleId(state){
      state.searchArticleId = ''
    },
    closeBox(state){
      state.helpBoxStatus = false
    },
    setActive(state,data){
      state.setActive = data
    },
    record(state){
      state.isAlert = true
    },
    clearHref(state){
      state.inHref = ''
    },
    setHref(state,data){
      state.inHref = data
    }
  },
  actions: {
    getHelpList(store,data){
      if(data.type === 'helpDoc'){
        console.log(data.list)
        store.commit('changeNavList',data.list.length > 0 ? data.list[0].children : [])
      }else{
        store.commit('changeNavList',data.length > 0 ? data : [])
      }
    },
    setSerachArticle(store,data){
      store.commit('changeSearchArticleId',data)
    },
    clearSearchArticle(store){
      store.commit('clearSearchArticleId')
    },
    closeHelpBox(store){
      store.commit('closeBox')
      store.commit('clearSearchArticleId')
    },
    setActiveIndex(store,data){
      store.commit('setActive',data)
    },
    recordAlert(store){
      store.commit('record')
    },
    setInHref(store,data){
      store.commit('setHref',data)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/helpCenter.js